module.exports = __webpack_public_path__ + "img/face1.9c60daee.png";